// src/components/store/sections/testimonials/TestimonialV88ClayreviewsOceanCyan.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV88ClayreviewsOceanCyan(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={88}
      archKey="clay_reviews"
      archLabel="3D Clay Review Deck"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
